import { Component, OnInit, ViewChild } from '@angular/core';
import { UnidadesEmpresaService } from '@services';
import { getErrorMessage } from '@utils';
import { UnidadesMedidaViewModel } from 'models/unidades-medida/UnidadesMedidaViewModel';
import { finalize } from 'rxjs';
import { ComboboxProdutoComponent } from '../../../dim-componentes/combobox-produto/combobox-produto.component';
import { ConverterNotasFiscaisEntradaItensViewModel } from '../../../model/ConverterNotasFiscaisEntradaItensViewModel';
import ItemFornecedor from '../../../model/ItemFornecedorViewModel';
import { ParametrosGeraisViewModel } from '../../../model/ParametrosGeraisViewModel';
import { AlmoxarifadosService } from '../../../services/almoxarifados.service';
import { ItensService } from '../../../services/itens.service';
import { MessageService } from '../../../services/message.service';
import { NFEntradaService } from '../../../services/nfentrada.service';
import { UnidadesEmpresaParametrosService } from '../../../services/unidades-empresa-parametros.service';
import { UnidadesMedidaService } from '../../../services/unidades-medida.service';
import { AbrirModalComponent } from '../../../shared/abrir-modal/abrir-modal.component';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { TempModalCadastroComponent } from '../../../shared/templates/temp-modal-cadastro/temp-modal-cadastro.component';

@Component({
  selector: 'app-itens-manifesto',
  templateUrl: './itens-manifesto.component.html',
  styleUrls: ['./itens-manifesto.component.css']
})
export class ItensManifestoComponent extends ModalCadastroComponent implements OnInit {

  constructor(
    private nfeEntradaService: NFEntradaService,
    private itensService: ItensService,
    private messageService: MessageService,
    private almoxarifadoService: AlmoxarifadosService,
    private unidadesMedidaService: UnidadesMedidaService,
    private parametrosService: UnidadesEmpresaParametrosService,
    private unidadesEmpresaService: UnidadesEmpresaService,
  ) { super(); }

  @ViewChild('abrirModal', { static: true }) abrirModal: AbrirModalComponent;
  @ViewChild('modalConsultar', { static: true }) modalConsultar: TempModalCadastroComponent;
  itens: RetornoBuscarItensFornecedoresViewModel[];
  loading = false;
  loadingData = false;
  almoxarifados: any[];
  almoxarifadoPadraoId: number;
  unidadesMedida: UnidadesMedidaViewModel[];
  movimentarEstoque = false;
  naoVincularItens = false;
  unidadeEmpresa = null;
  aliquotasPisCofins = null;

  dictStatusItem = {
    cadastroMovimentado: 'cm',
    cadastraoNaoMovimentado: 'cnm',
    naoCadastradoNaoMovimentado: 'ncnm'
  }

  dictStatusItemCor = {
    cm: 'primary',
    cnm: 'info',
    ncnm: 'danger',
  }

  dictStatusItemNgbTooltip = {
    cm: 'Cadastrado e movimentado',
    cnm: 'Cadastrado e não movimentado',
    ncnm: 'Não cadastrado e não movimentado',
  }

  dictStatusSelecionados = {
    ok: 'ok',
    cnmSelecionado: 'cnm1',
    cnmSelecionados: 'cnm2',
    cnmComNcnmSelecionado: 'cnm_ncnm1',
    cnmComNcnmSelecionados: 'cnm_ncnm2',
  }

  dictStatusSelecionadosError = {
    ok: '',
    cnm1: 'O item selecionado já foi cadastrado.<br> Ative a opção <b>Movimentar Estoque</b> caso deseje movimentar o estoque.',
    cnm2: 'Os itens selecionados já foram cadastrados.<br> Ative a opção <b>Movimentar Estoque</b> caso deseje movimentar o estoque.',
    cnm_ncnm1: 'Um ou mais itens selecionados já estão cadastrados.<br> Ative a opção <b>Movimentar Estoque</b> caso deseje movimentar o estoque.',
    cnm_ncnm2: 'Um ou mais itens selecionados já estão cadastrados.<br> Ative a opção <b>Movimentar Estoque</b> caso deseje movimentar o estoque.',
  }

  ngOnInit() {
    const ID = this.prop['ID'];
    this.loading = true;
    this.loadingData = true;

    this.unidadesEmpresaService.getUnidadeEmpresa().subscribe(res => {
      this.unidadeEmpresa = res;
    });

    this.itensService.buscarAliquotasPISCOFINS().subscribe(res => {
      this.aliquotasPisCofins = res;
    });

    this.nfeEntradaService.buscarItensFornecedores(ID).subscribe((res: RetornoBuscarItensFornecedoresViewModel[]) => {
      this.itens = res.map(i => {
        i.quantidadeEstoque = i.quantidade;
        if (i.itemFornecedor.itemID) {
          i.unidadeMedidaID = i.itemFornecedor.item.unidadeMedidaID;
          i.precoVenda = i.itemFornecedor.item.precoSaida;
        } else {
          i.nome = i.itemFornecedor.nome;
        }

        return i;
      });
    }, (err) => { }, () => {
      this.loading = false;
      this.loadingData = false;
    });

    this.carregaAlmoxarifados();
    this.carregaUnidadesMedida();
    this.parametrosService.getParametrosGerais()
      .subscribe((parametros: ParametrosGeraisViewModel) => {
        if (parametros.almoxarifadoPadraoId) {
          this.almoxarifadoPadraoId = parametros.almoxarifadoPadraoId;
        }
      }, error => {
      });
  }

  show() {
    this.modalConsultar.show();
  }

  destroyComponent() {
    this.closed.emit();
  }

  get possuiItensSelecionados(): boolean {
    return this.selecionados.length === 0
  }

  get itensNaoMovimentados(): RetornoBuscarItensFornecedoresViewModel[] {
    if (!this.itens) {
      return [];
    }

    return this.itens.filter(item => !item.movimentouEstoque);
  }

  importar() {
    if (!this.almoxarifadoPadraoId) {
      this.messageService.addError({
        title: 'Almoxarifado',
        msg: 'Informe um almoxarifado para os itens que serão cadastrados.',
        showClose: false,
        timeout: 7000,
        theme: 'bootstrap',
        closeOther: true
      });
      return;
    }

    this.messageService.addToast({
      title: 'Cadastrando produtos',
      msg: 'Aguarde alguns instantes...',
      showClose: true, timeout: 0, theme: 'bootstrap', closeOther: true, type: 'wait'
    });

    this.loading = true;

    const data: ConverterNotasFiscaisEntradaItensViewModel = {
      itens: this.selecionados,
      movimentarEstoque: this.movimentarEstoque,
      naoVincularItens: this.naoVincularItens,
      almoxarifadoPadraoId: this.almoxarifadoPadraoId,
      notaFiscalEntradaId: this.prop['ID'],
      configuracao: this.prop['configuracao']
    };

    this.itensService.converterItensFornecedores(data)
      .subscribe(res => {
        this.messageService.success('Itens de venda cadastrados com sucesso', 5000)
      }, err => {
        this.loading = false;
        this.messageService.error(getErrorMessage(err), 5000)
      }, () => {
        this.loading = false;
        this.modalConsultar.hide();
        this.closed.emit(true);
      });
  }

  carregaAlmoxarifados(): void {
    this.loading = true;
    this.almoxarifadoService.get()
      .pipe(finalize(() => this.loading = false))
      .subscribe(response => {
        this.almoxarifados = response;
      });
  }

  statusCadastroMovimentacaoItem(item: RetornoBuscarItensFornecedoresViewModel): string {
    if (item.itemFornecedor.itemID) {
      if (item.movimentouEstoque) {
        return this.dictStatusItem.cadastroMovimentado;
      } else {
        return this.dictStatusItem.cadastraoNaoMovimentado;
      }
    }
    return this.dictStatusItem.naoCadastradoNaoMovimentado;
  }

  statusItemCor(row: RetornoBuscarItensFornecedoresViewModel): string {
    let status = this.statusCadastroMovimentacaoItem(row);
    if (this.dictStatusItemCor.hasOwnProperty(status)) {
      return this.dictStatusItemCor[status];
    }
    return '';
  }

  statusItemNgbTooltip(row: RetornoBuscarItensFornecedoresViewModel): string {
    let status = this.statusCadastroMovimentacaoItem(row);
    if (this.dictStatusItemNgbTooltip.hasOwnProperty(status)) {
      return this.dictStatusItemNgbTooltip[status];
    }
    return '';
  }


  statusSelecionados(): string {
    if (!this.selecionados.length) {
      return this.dictStatusSelecionados.ok;
    }

    const itensCNM = this.selecionados.filter(item => this.statusCadastroMovimentacaoItem(item) == this.dictStatusItem.cadastraoNaoMovimentado);
    const itensNCNM = this.selecionados.filter(item => this.statusCadastroMovimentacaoItem(item) == this.dictStatusItem.naoCadastradoNaoMovimentado);

    if (itensCNM.length === this.selecionados.length) {
      if (itensCNM.length === 1) {
        return this.dictStatusSelecionados.cnmSelecionado;
      } else {
        return this.dictStatusSelecionados.cnmSelecionados;
      }
    } else if (itensCNM.length && itensNCNM.length) {
      if (itensNCNM.length === 1) {
        return this.dictStatusSelecionados.cnmComNcnmSelecionado;
      } else {
        return this.dictStatusSelecionados.cnmComNcnmSelecionados;
      }
    }

    return this.dictStatusSelecionados.ok;
  }

  statusSelecionadosError(): string {
    const status = this.statusSelecionados();
    if (this.dictStatusSelecionadosError.hasOwnProperty(status)) {
      return this.dictStatusSelecionadosError[status];
    }
    return '';
  }

  carregaUnidadesMedida() {
    this.loading = true;
    this.unidadesMedidaService.get()
      .pipe(finalize(() => this.loading = false))
      .subscribe((response: UnidadesMedidaViewModel[]) => {
        this.unidadesMedida = response;
      });
  }

  abrirCadastroAlmoxarifado(id, searchTerm) {
    const sub = this.abrirModal.closed.subscribe(res => {
      sub.unsubscribe();
      this.carregaAlmoxarifados();
      this.almoxarifadoPadraoId = res;
    });

    if (id) {
      this.abrirModal.editar('almoxarifado', id);
    } else {
      this.abrirModal.cadastrar('almoxarifado', searchTerm);
    }
  }

  get selecionados() {
    return this.itens?.filter(item => item.selecionado) ?? [];
  }

  selecionarTodos(ev) {
    const checked = ev.target.checked;

    for (const item of this.itens) {
      item.selecionado = checked;
    }
  }

  createViewDetalhaItem(row: RetornoBuscarItensFornecedoresViewModel, ev, combo: ComboboxProdutoComponent) {
    const editarId = ev.id;
    const nome = !ev.id ? ev : null;

    const sub = this.abrirModal.closed.subscribe(res => {
      sub.unsubscribe();

      if (res?.itemId) {
        row.novoItemID = res.itemId;
        row.unidadeMedidaID = res.unidadeMedidaID;
        row.precoVenda = res.precoSaida;

        // Força carregamento do produto para refletir a edição do código/descrição.
        combo.carregaidProdutoSelecionado(true);
      }
    });

    const simplesOuMei = [1, 4].includes(this.unidadeEmpresa.crt);
    const cstIpi = simplesOuMei ? '52' : row.aliquotaIPI > 0 ? '50' : '52';
    const aliquotaIpi = simplesOuMei ? null : row.aliquotaIPI;
    const cstPis = simplesOuMei ? '99' : '01';
    const aliquotaPis = simplesOuMei ? null : this.aliquotasPisCofins?.aliquotaPIS;
    const cstCofins = simplesOuMei ? '99' : '01';
    const aliquotaCofins = simplesOuMei ? null : this.aliquotasPisCofins?.aliquotaCOFINS;

    this.abrirModal.abrir('produtos', {
      id: editarId,
      preencherDados: {
        nome: nome,
        classificacaoFiscalID: row.itemFornecedor.classificacaoFiscalID,
        almoxarifadoPadraoId: this.almoxarifadoPadraoId,
        unidadeMedidaID: row.unidadeMedidaID,
        extipi: row.itemFornecedor.extIpi,
        codigoANP: row.itemFornecedor.codigoANP,
        uTrib: row.itemFornecedor.uTrib,
        fatorConversaoUtrib: row.itemFornecedor.fatorConversaoUtrib,
        precoSaida: row.precoVenda,
        custoCompra: row.custoEntrada,
        cstIpi,
        aliquotaIpi,
        cstPis,
        aliquotaPis,
        cstCofins,
        aliquotaCofins,
        tipoItemid: 1, // Mercadoria para Revenda
      },
    });
  }

  produtoChanged(row: RetornoBuscarItensFornecedoresViewModel, ev, combo: ComboboxProdutoComponent) {
    row.codigo = ev?.referenciaItem;
    row.precoVenda = ev?.precoSaida;
    row.unidadeMedidaID = ev?.unidadeMedidaID;
    combo.blur(); // Para selecionar o produto automaticamente quando existe só 1 para o filtro digitado.
  }
}

interface RetornoBuscarItensFornecedoresViewModel {
  id: number;
  itemFornecedorID: number;
  itemFornecedor: ItemFornecedor;
  quantidade: number;
  custoEntrada: number;
  precoVenda: number;
  unidadeMedidaID: number;
  movimentouEstoque: boolean;
  aliquotaIPI: number;

  selecionado: boolean;
  quantidadeEstoque: number;
  nome: string;
  codigo: string;
  novoItemID: number;
  validade: Date;
}